import { z } from 'zod';

export const leaveTypeSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  code: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
});

export const leaveTypeListSchema = z.array(leaveTypeSchema);

export type LeaveType = z.infer<typeof leaveTypeSchema>;

export const leaveTypeFormSchema = z.object({
  code: z.string().trim().min(1, 'Code is required').max(50, 'Code must be 50 characters or fewer'),
  name: z.string().trim().min(1, 'Name is required').max(50, 'Name must be 50 characters or fewer'),
  description: z.string().trim().max(500, 'Description must be 500 characters or fewer'),
  isActive: z.boolean(),
});

export type LeaveTypeFormValues = z.infer<typeof leaveTypeFormSchema>;

export interface CreateLeaveTypePayload {
  name: string;
  code: string;
  description?: string;
  isActive?: boolean;
}

export type UpdateLeaveTypePayload = Partial<CreateLeaveTypePayload>;
